module.exports = __webpack_public_path__ + "media/members/download_spreadsheet-904f0cf5.png";